// i18n area 'auth' — locale hr-HR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.hr-HR.meta.json.
import type { enUS } from './auth'

export const hrHR: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Prijavite se u svoj račun',
    username: 'Korisničko ime',
    usernamePlaceholder: 'Unesite korisničko ime',
    usernameHint: 'Upotrijebite korisnik@domena za prijavu na realm direktorija',
    continue: 'Nastavi',
    changeUser: 'Niste vi?',
    password: 'Lozinka',
    forgotPassword: 'Zaboravili ste lozinku?',
    submit: 'Prijavi se',
    otp: 'Jednokratni kod',
    otpSubtitle: 'Unesite kod iz svog autentifikatora',
    otpHint: 'Šest znamenki iz aplikacije za autentifikaciju ili jedan od kodova za oporavak',
    otpSubmit: 'Provjeri',
    invalidCredentials: 'Neispravno korisničko ime ili lozinka',
    tooManyAttempts: 'Previše pokušaja — pričekajte trenutak i pokušajte ponovno',
    realmUnavailable: 'Realm trenutačno ne može provjeriti vjerodajnice — store klastera nije dostupan. Prijavite se kao lokalni korisnik (break-glass).',
    genericError: 'Prijava nije uspjela — je li TVirt backend dostupan?'
  },
  user: {
    logout: 'Odjava',
    password: {
      menu: 'Promijeni lozinku',
      title: 'Promijenite svoju lozinku',
      current: 'Trenutačna lozinka',
      new: 'Nova lozinka',
      confirm: 'Potvrdite novu lozinku',
      mismatch: 'Lozinke se ne podudaraju',
      error: 'Lozinku nije moguće promijeniti',
      forcedTitle: 'Promijenite lozinku za nastavak',
      forcedHint: 'Ovu je lozinku postavio administrator i mora se zamijeniti prije ulaska.',
      forcedSubmit: 'Promijeni i uđi'
    },
    mfa: {
      title: 'Dvofaktorska autentifikacija',
      subtitle: 'Drugi faktor koji se traži pri svakoj prijavi',
      loadError: 'Stanje drugog faktora nije moguće učitati',
      enrolled: 'Aktivan',
      notEnrolled: 'Nije aktivan',
      enrolledAt: 'Aktiviran',
      codesRemaining: 'Preostali kodovi za oporavak',
      requiredHint:
        'Administrator zahtijeva drugi faktor na ovom računu: postavite ga sada — dok to ne učinite, možete se prijaviti, ali malo više od toga.',
      enroll: 'Postavi',
      enrollTitle: 'Postavite dvofaktorsku autentifikaciju',
      enrollHint: 'Skenirajte ovaj kod aplikacijom za autentifikaciju, zatim upišite kod koji prikazuje kako biste potvrdili.',
      secretHint: 'Ne možete skenirati? Umjesto toga upišite ovaj tajni ključ u aplikaciju:',
      code: 'Kod iz aplikacije',
      confirm: 'Potvrdi',
      startError: 'Postavljanje nije moguće pokrenuti',
      confirmError: 'Postavljanje nije moguće potvrditi',
      codesTitle: 'Vaši kodovi za oporavak',
      codesWarning:
        'Ovi se kodovi prikazuju samo jednom. Spremite ih sada: svaki vas prijavljuje kada autentifikator nije dostupan i svaki vrijedi samo jednom.',
      codesAck: 'Kodovi za oporavak su spremljeni',
      codesDone: 'Gotovo',
      copy: 'Kopiraj',
      copied: 'Kopirano',
      download: 'Preuzmi',
      regenerate: 'Novi kodovi za oporavak',
      regenerateTitle: 'Ponovno generirajte kodove za oporavak',
      regenerateHint: 'Svi dosad izdani kodovi prestaju vrijediti u trenutku kada se generira novi skup.',
      regenerateConfirm: 'Generiraj ponovno',
      regenerateError: 'Kodove za oporavak nije moguće ponovno generirati',
      remove: 'Ukloni',
      removeTitle: 'Uklonite drugi faktor',
      removeConfirm: 'Ukloni',
      removeHint: 'Račun se vraća na samo lozinku. Drugi faktor možete ponovno postaviti kad god želite.',
      removeRequiredHint:
        'Administrator zahtijeva drugi faktor na ovom računu, pa će poslužitelj odbiti uklanjanje — zamolite ga da prvo ukine obvezu.',
      removeError: 'Drugi faktor nije moguće ukloniti'
    },
    profile: {
      menu: 'Idi na moj profil',
      sessions: 'Aktivne sesije',
      sessionsHint: 'Vaše otvorene sesije na ovom čvoru',
      sessionsEmpty: 'Nema aktivnih sesija',
      sessionCreated: 'Prijava izvršena',
      sessionExpires: 'Istječe',
      revoke: 'Opozovi sesiju',
      revokeError: 'Sesiju nije moguće opozvati',
      loadError: 'Sesije nije moguće učitati'
    }
  }
}
